import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { forEach as _forEach, cloneDeep as _cloneDeep, isUndefined as _isUndefined} from 'lodash-es';
import { StudioFormInputElementTypes } from 'src/app/connector-studio/models/inputElementTypes.model';
import { StepsBuilderHelperService } from 'src/app/connector-studio/services/steps-builder-helper/steps-builder-helper.service';
import { RepeatFieldConfig } from 'src/app/connector-studio/components/multi-composition/repeat.config';
import { v4 as createId } from 'uuid';

type StepBuilderRepeatFieldConfig = RepeatFieldConfig & {
  dynamicRepeatParams?: any;
}

@Component({
  selector: 'app-dnd-accordion',
  templateUrl: './dnd-accordion.component.html',
  styleUrls: ['./dnd-accordion.component.scss']
})
export class DndAccordionComponent extends  FieldArrayType<StepBuilderRepeatFieldConfig> implements OnInit {
  panelOpenState = true;
  constructor(public stepsBuilderHelperService: StepsBuilderHelperService) {
    super();
  }

  ngOnInit(): void {
    console.log(this.field)
  }

  addFieldForStepBuilder(event) {
    event.stopPropagation();
    const data = _cloneDeep(StudioFormInputElementTypes[8])
    this.stepsBuilderHelperService.addFieldThroughClick(data, this.field);
  }

  accordionClickHandler(event) {
    event.stopPropagation();
  }
}